import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';
import { save, load, clear } from "redux-localstorage-simple"

const appConfig = { namespace: "anglo_training_register" }
const createStoreWithMiddleware = compose(applyMiddleware(thunk, save(appConfig)))(createStore)
let store = createStoreWithMiddleware(reducer,load(appConfig))

const clearNamespace = () => {
  clear(appConfig)
}

export { store, clearNamespace }



// WEBPACK FOOTER //
// ./src/store.js